export const parseLocalStorage = (key: string) => {
	const value = window.localStorage.getItem(key)

	if (value == null) {
		return null
	}
	return JSON.parse(value)
}
